module.exports = {
  path: 'fullscreen',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Fullscreen').default || require('./components/Fullscreen'));
    }, 'fullscreen');
  }
};



// WEBPACK FOOTER //
// ./routes/fullscreen/index.js